<script>
  import {firebaseUser, signOut} from "../auth/authStore";
  import {showConfirm} from "../popup/popupStore";

  export let darkTheme = false;

  let dropdownOpened = false;


  const toggleDropdown = () => dropdownOpened = !dropdownOpened;

  const onSignOutClick = async () => {
    if (await showConfirm('Are you sure you want to sign out?')) {
      signOut();
    }
  };

</script>

<row class="channel-list-profile" align-center class:dark={darkTheme} class:dropdown-open={dropdownOpened} on:click={toggleDropdown}>
  <column expand>
    <div class="logo">BLABLA</div>
    <div class="email">{$firebaseUser.email}</div>
  </column>
  <ion-icon class="open-indicator" name="caret-down-outline"></ion-icon>


  <column class="dropdown-menu">
    <row class="dropdown-menu-item clickable" align-center on:click={onSignOutClick}>
      <ion-icon name="log-out-outline"></ion-icon>
      Sign Out
    </row>
  </column>
</row>


<style>
  .channel-list-profile {
    cursor: pointer;
    padding: 12px;
    position: relative;
    border-bottom: 1px solid #ccc;
  }

  .channel-list-profile.dark {
    color: white;
    border-bottom-color: #333;
  }

  .logo {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: black;
    z-index: 1;
    box-shadow: 0 1px 1px #ccc;
    max-height: 0;
    transition: max-height .2s;
    overflow: hidden;
    color: white;
  }

  .dropdown-menu-item {
    padding: 0 12px;
    height: 32px;
    font-size: 0.9rem;
    cursor: pointer;
  }

  .dropdown-menu-item ion-icon {
    margin-right: 8px;
    font-size: 1.1rem;
  }

  .dark .dropdown-menu {
    background-color: white;
    color: #333;
  }

  .dropdown-open .dropdown-menu {
    max-height: 40px;
  }

  .open-indicator {
    transition: transform .2s;
  }

  .dropdown-open .open-indicator {
    transform: rotate(180deg);
  }
</style>
